import { Icon, type IconName } from '@/components/common/Icon';
import { Card } from '@/components/ui/card';

interface EmptyStateProps {
  iconName: IconName;
  title: string;
  description: string;
}

export function EmptyState({ iconName, title, description }: EmptyStateProps) {
  return (
    <Card
      variant="dashed"
      padding="lg"
      className="p-12 flex flex-col items-center justify-center text-center"
    >
      <div className="w-16 h-16 rounded-2xl bg-zoovpalelavender flex items-center justify-center mb-4">
        <Icon name={iconName} className="text-2xl text-zooprimary" />
      </div>
      <h2 className="font-bold text-zooindigo">{title}</h2>
      <p className="text-sm text-zoomuted mt-1.5 max-w-sm">{description}</p>
    </Card>
  );
}
